import React from "react";
import { Icon } from "@chakra-ui/react";

export const Yesem = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 67 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M29.2316 8.99859C27.9194 9.49322 25.9387 9.8254 24.1804 9.84109H24.0346C20.2016 9.84109 18.8399 9.30332 18.8399 6.27168L18.8309 3.23835V3.2165H16.6055L16.615 6.27392C16.615 8.45522 17.2475 9.9492 18.549 10.8449C19.6552 11.6079 21.2234 11.9613 23.6334 11.9966V12H24.0324L24.0341 11.9983C24.6862 11.9983 26.9792 11.9473 29.2305 11.2796V11.8157H31.4559V3.21594H29.2305V8.99859H29.2316Z"
        fill="currentColor"
      />
      <path
        d="M35.2869 0H33.0615V6.2728L33.0694 6.65931H33.0745C33.1482 8.68433 33.8105 10.0736 35.1024 10.9116C36.2058 11.628 37.7442 11.9613 40.0861 11.9944V11.9989H40.489C41.1411 11.9989 43.4341 11.9479 45.6854 11.2802V11.8162H47.9108V6.19269H45.6854V9.00027C44.3732 9.4949 42.3925 9.82708 40.6342 9.84277H40.4884C36.6554 9.84277 35.2948 9.30332 35.2948 6.27336L35.2869 5.3726H48.285V3.21594H35.2869V0.000560077V0Z"
        fill="currentColor"
      />
      <path
        d="M2.22542 3.05176e-05H0V6.27283L0.00787768 6.65934H0.0151926C0.0872164 8.68436 0.751186 10.0736 2.0448 10.9116C3.14823 11.6281 4.68661 11.9614 7.02851 11.9944V11.9989H7.42746C8.07848 11.9989 10.3714 11.9479 12.6239 11.2802V11.8163H14.8493V6.19272H12.6239V9.0003C11.3117 9.49493 9.33103 9.82711 7.57207 9.8428H7.42746C3.59444 9.8428 2.23274 9.30335 2.23274 6.27339L2.22542 5.37263H15.2235V3.21597H2.22542V0.000590595V3.05176e-05Z"
        fill="currentColor"
      />
      <path
        d="M62.3023 0V9.00139C60.9901 9.49602 59.0094 9.82596 57.251 9.84389H57.1081C53.2751 9.84389 51.9134 9.30445 51.9134 6.2728L51.9044 3.23947V3.21762H49.6807L49.6885 6.27504C49.6885 8.45635 50.321 9.95032 51.6214 10.846C52.7282 11.6073 54.2986 11.9625 56.7069 11.9949V11.9994H57.1059C57.7552 11.9994 60.0465 11.9462 62.3017 11.2807V11.8151H64.5316V2.15946H66.8488V0.000560077H62.3017L62.3023 0Z"
        fill="currentColor"
      />
    </Icon>
  );
};
